export const CUSTOM = "CUSTOM"
export const PERSONAL_QUESTIONNAIRE = "PERSONAL_QUESTIONNAIRE"
export const BUSINESS_QUESTIONNAIRE = "BUSINESS_QUESTIONNAIRE"